<template>
  <v-container>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Files
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            class="pt-2"
          >
            <v-col
              v-for="file in files"
              :key="file.id"
              cols="12"
              md="4"
              lg="3"
            >
              <v-card
                outlined
                hover
                class="pa-2"
                @click="downloadFile(file.path)"
              >
                <v-card-text>
                  <v-icon>{{ filetypes[file.name.split(".").reverse()[0]] }}</v-icon>
                  <span class="pl-4 text-h4">
                    {{ file.name }}
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'ContractFiles',
    props: {
      files: Array,
    },
    data () {
      return {
        filetypes: {
          pdf: 'mdi-file-pdf',
          png: 'mdi-file-image',
          txt: 'mdi-file-document-outline',
          sql: 'mdi-database',
        },
      }
    },
    computed: {
      ...get('settings', [
        'settings'
      ]),
    },
    methods: {
      downloadFile: async function (path) {
        let url = 'https://gitlab.com/api/v4/projects/' + this.settings.gitlab_repository_id + '/repository/files/' + encodeURIComponent(path) + '?ref=main'

        let response = await fetch(url, {
          headers: {
            "PRIVATE-TOKEN": this.settings.gitlab_token
          }
        })
        let file = await response.json()
        let filename = decodeURI(file.file_name)
        const fileurl = window.URL.createObjectURL(new Blob([atob(file.content)]))
        const link = document.createElement('a')
        link.href = fileurl
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(fileurl)
        link.remove()
      }
    }
  }
</script>
